








import Vue from 'vue';
import CookieConsent from '@/components/CookieConsent.vue';

export default Vue.extend({
  components: { CookieConsent },
  mounted() {
    if (this.$exp.name === 'color-mode') {
      this.$store.dispatch(
        'changeColorMode',
        this.$exp.$activeVariants[0].name
      );
    }
  },
});
